"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Instagram, Twitter, Linkedin, Facebook } from "lucide-react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="17896" className="flex gap-6 animate-pulse">
        <div className="h-4 w-16 bg-primary/10 rounded-sm" />
        <div className="h-4 w-20 bg-primary/10 rounded-sm" />
        <div className="h-4 w-14 bg-primary/10 rounded-sm" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-wrap justify-center gap-x-8 gap-y-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-sm font-sans font-medium text-muted-foreground hover:text-primary transition-colors duration-300 tracking-wide" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground border-t border-primary/20 py-8">
      <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4">
        {}
        <div className="shrink-0 order-2 md:order-1">
          <Link to="/HomePage" className="block">
            <img src="https://pupzstudio.10web.cloud/wp-content/uploads/2026/03/image_bxsocfvs.png" alt="PupzStudio" className="h-28 w-auto opacity-80 hover:opacity-100 transition-all duration-500 brightness-125" />
          </Link>
        </div>

        {}
        <div className="flex-1 flex justify-center order-1 md:order-2 w-full md:w-auto">
          <MenuProvider menu_id="35" className="w-full flex justify-center">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="shrink-0 flex flex-col items-center md:items-end gap-3 order-3 text-right">
          {}
          <div className="flex items-center gap-4">
            {[{
            icon: Instagram,
            href: "https://instagram.com"
          }, {
            icon: Twitter,
            href: "https://twitter.com"
          }, {
            icon: Linkedin,
            href: "https://linkedin.com"
          }].map((social, i) => <Link key={i} to={social.href} newTab className="text-muted-foreground hover:text-primary transition-all duration-300 hover:scale-110" data-index={i} aria-label="Social Link">
                <social.icon size={18} strokeWidth={1} />
              </Link>)}
          </div>

          {}
          <div className="text-[10px] font-sans tracking-widest text-muted-foreground/70 uppercase flex flex-col md:flex-row gap-1 md:gap-3 items-center md:items-end">
            <span>&copy; {currentYear} PupzStudio</span>
            <span className="hidden md:inline text-primary/20">|</span>
            <span>Custom Website Digital Concierge</span>
          </div>
        </div>
      </div>
    </section>;
}